/**
 * Shared status colouring for resource views (GDN-2723).
 *
 * Lifted verbatim from the bespoke encounter/appointment/transcription pages,
 * which each carried their own copy of this switch. One definition means a
 * "cancelled" reads the same colour wherever it appears.
 */

export type StatusTone =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'error'
  | 'info'
  | 'success'
  | 'warning';

export function statusTone(status: string | undefined | null): StatusTone {
  if (!status) return 'default';

  switch (status.toLowerCase()) {
    case 'completed':
    case 'success':
    case 'active':
    case 'signed':
      return 'success';
    case 'scheduled':
      return 'info';
    case 'pending':
    case 'processing':
    case 'in_progress':
      return 'warning';
    case 'failed':
    case 'error':
    case 'cancelled':
      return 'error';
    case 'draft':
    case 'inactive':
      return 'secondary';
    default:
      return 'default';
  }
}
